import type { FC } from "react";
import { Doughnut } from "../../shared/components/Doughnut/Doughnut";
import { IconNames } from "../../shared/components/Icon/svg";
import { Sharing } from "../../shared/components/Sharing/Sharing";
import { Token } from "../../shared/components/Token/Token";
import classes from "./Tokenomics.module.scss";
import { v4 as uiidv4 } from "uuid";

export interface SharingType {
	name: IconNames;
	title: string;
	text: string;
}

export const Tokenomics: FC = () => {
	const sharing: SharingType[] = [
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
		{ name: "coin", title: "Name of sharing", text: "Name of sharing" },
	];

	return (
		<div className={classes.wrapper}>
			<h2 className={classes.title}>Tokenomics</h2>
			<div className={classes.token}>
				<Token name="line" title="Spending Tokens">
					Our tokens offer a range of uses! Spend them on premium features,
					exclusive merchandise, or special game content.
				</Token>
				<Token name="line1" title="Status and Schedule">
					Our tokens have a predefined release schedule to ensure consistent
					supply and maintain market stability.
				</Token>
			</div>

			<div className={classes.doughnut}>
				<Doughnut name="doughnut" title="Spending Tokens" />

				<Doughnut name="doughnut" title="Spending Tokens" />
			</div>

			<div className={classes.sharings}>
				<div className={classes.sharing}>
					<h4 className={classes.title}>Sharing</h4>
					<div className={classes.coin}>
						{sharing.map(({ name, title, text }) => (
							<Sharing key={uiidv4()} name={name} title={title}>
								{text}
							</Sharing>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
